export default "__VITE_ASSET__1a11fffe__"